export default __webpack_public_path__ + "static/media/_DSC0548.d9e75fd1.JPG";